/**
 * WebSocket message types for ElevenLabs Conversational AI API
 */

// Client to Server Message Types
export const CLIENT_MESSAGE_TYPES = {
  CONVERSATION_INITIATION: 'conversation_initiation_client_data',
  USER_AUDIO_CHUNK: 'user_audio_chunk',
  PONG: 'pong',
  CLIENT_TOOL_RESULT: 'client_tool_result',
  CONTEXTUAL_UPDATE: 'contextual_update',
  USER_MESSAGE: 'user_message',
  USER_ACTIVITY: 'user_activity'
};

// Server to Client Message Types
export const SERVER_MESSAGE_TYPES = {
  CONVERSATION_INITIATION_METADATA: 'conversation_initiation_metadata',
  VAD_SCORE: 'vad_score',
  USER_TRANSCRIPT: 'user_transcript',
  INTERNAL_TENTATIVE_AGENT_RESPONSE: 'internal_tentative_agent_response',
  AGENT_RESPONSE: 'agent_response',
  AUDIO: 'audio',
  PING: 'ping',
  CLIENT_TOOL_CALL: 'client_tool_call',
  AGENT_RESPONSE_CORRECTION: 'agent_response_correction',
  INTERRUPTION: 'interruption',
  CONTEXTUAL_UPDATE: 'contextual_update'
};

// Connection States
export const CONNECTION_STATES = {
  IDLE: 'idle',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
  ERROR: 'error'
};

// Audio Formats
export const AUDIO_FORMATS = {
  PCM_16000: 'pcm_16000',
  PCM_22050: 'pcm_22050',
  PCM_44100: 'pcm_44100'
};

// Language Codes
export const LANGUAGE_CODES = {
  ENGLISH: 'en',
  SPANISH: 'es',
  FRENCH: 'fr',
  GERMAN: 'de',
  ITALIAN: 'it',
  PORTUGUESE: 'pt',
  POLISH: 'pl',
  TURKISH: 'tr',
  RUSSIAN: 'ru',
  DUTCH: 'nl',
  CZECH: 'cs',
  ARABIC: 'ar',
  CHINESE_SIMPLIFIED: 'zh-cn',
  CHINESE_TRADITIONAL: 'zh-tw',
  JAPANESE: 'ja',
  KOREAN: 'ko',
  HINDI: 'hi'
};